import type { ExploreContentItemContentOneOfReferencedTweetTweetAuthor } from './exploreContentItemContentOneOfReferencedTweetTweetAuthor';
import type { ExploreContentItemContentOneOfReferencedTweetTweetBasicInfo } from './exploreContentItemContentOneOfReferencedTweetTweetBasicInfo';
import type { ExploreContentItemContentOneOfReferencedTweetTweetEngagement } from './exploreContentItemContentOneOfReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type ExploreContentItemContentOneOfReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: ExploreContentItemContentOneOfReferencedTweetTweetAuthor;
  basicInfo?: ExploreContentItemContentOneOfReferencedTweetTweetBasicInfo;
  engagement?: ExploreContentItemContentOneOfReferencedTweetTweetEngagement;
};
